import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CategoryForm = () => {
  const [category, setCategoryName] = useState('');
  const [buttonvalue, setbuttonvalue] = useState("Create Category");
  

  const handleSubmit = async () => {
    if (!category) {
      toast.error('Please enter the category name.');
    } else {
      try {
        setbuttonvalue("Creating")
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/category/add_category`, {
          categoryname: category,
        });
        if (response.status === 200) {
          toast.success('Category created successfully!');
          setCategoryName('');
          setbuttonvalue("Create Category")
        }
      } catch (error) {
        console.log(error.message);
        toast.error('An error occurred while creating the category.');
      }
    }
  };

  return (
    <>
      <div className="main flex flex-col items-center justify-center">
        <h1 className="text-3xl font-semibold mb-6 text-green-800">Category Module</h1>

        <label htmlFor="category" className="text-lg mb-2">
          Enter Category's name
        </label>
        <input
          type="text"
          name="category"
          id="category"
          placeholder="Category name"
          autoComplete="off"
          value={category}
          onChange={(e) => setCategoryName(e.target.value)}
          className="px-3 py-2 border w-full rounded-lg shadow-md focus:outline-none focus:ring focus:border-blue-300"
        />

        <button
          className="bg-green-800 text-white py-2 w-full flex justify-center rounded-md hover:bg-green-700"
          onClick={handleSubmit}
        >
          {buttonvalue}
        </button>

        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        
        <article className="md:grid grid-cols-2 gap-10"></article>
      </div>
    </>
  );
};

export default CategoryForm;